import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Note extends BaseModel {
  static modelName = 'Note'

  static instanceDefaults() {
    return {
      title: '',
      // null, not '': the list is fetched without bodies, so a note in the
      // store usually has no content yet. null means "not fetched", '' means
      // "fetched and genuinely empty". Anything that reads or writes a body
      // must check hasContent() first -- see lib/notes.js. Defaulting this to
      // '' would let an unopened note be saved back as blank.
      content: null,
      excerpt: '',
      pinned: false,
      archived: false,
      taskSync: true
    }
  }
}

const servicePath = 'notes'
const servicePlugin = makeServicePlugin({
  Model: Note,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
